const LowEmphasisUpsellConfig = [
    { span: 10, height: "24px", classes: "marginTop-24" },
    { span: 10, height: "96px", classes: "marginTop-8" },
    { span: 10, height: "40px", classes: "marginTop-16" },
    { span: 10, height: "1px", classes: "marginTop-16" },
    { span: 10, height: "21px", classes: "marginTop-16" },
]
export default LowEmphasisUpsellConfig
